import { Components } from "appworks/components/components";
import { Contract } from "appworks/utils/contracts/contract";
import { Sequence } from "appworks/utils/contracts/sequence";
import { GamevyFreeGamesComponent } from "gamevy/components/gamevy-freegames-component";
import { IdleGamble } from "slotworks/state-machine/standard/states/idle-gamble";

export class GamevyIdle extends IdleGamble {

    public onEnter(): void {
        super.onEnter();
        Components.get(GamevyFreeGamesComponent)?.update()?.execute();
    }

    protected collect(): Contract<void> {
        return new Sequence([
            () => super.collect(),
            () => Components.get(GamevyFreeGamesComponent)?.update() ?? Contract.empty()
        ]);
    }
}
